


















import Element from '../../../mixins/element';
import { Component } from 'vue-property-decorator';

@Component
export default class Cvc extends Element {
    public cardCvc: any;

    public toMount() {
        this.loading = true;
        this.cardCvc = this.integrationData.elements.create('cardCvc', {
            style: this.integrationStyles.styles,
            classes: this.integrationStyles.classes,
        });

        const id = this.$el.id || 'str2_' + Math.round(Math.random() * 10000);
        this.$el.id = '';
        (this.$refs.target as HTMLElement).id = id;
        this.cardCvc.mount(`#${id}`);

        this.cardCvc.on('ready', () => {
            this.loading = false;
        });

        this.cardCvc.on('focus', () => {
            this.onFocus();
        });

        this.cardCvc.on('blur', () => {
            this.onBlur();
        });

        this.cardCvc.on('change', (data: any) => {
            const result: any = {
                ...data,
                isEmpty: data.empty,
            };
            delete result.empty;
            this.input = result;
        });
    }

    public toValidate(): boolean {
        return this.serializedData.complete || false;
    }

    public toClear() {
        this.cardCvc.clear('cardCvc');
    }

    public toDestroy() {
        this.cardCvc.destroy();
    }

    public toFocus(): void {
        this.cardCvc.focus();
    }

    public toBlur(): void {
        this.cardCvc.blur();
    }
}
